import { setExpiredAuth } from '../../../actions/travelUg/quote';
import {
    apiTransitionOrderConfirmation,
    confirmOrderSuccess,
    confirmOrderFailure,
    setSelectedFormValue,
} from '../../../actions/travelUg/payments';
import { getAccessToken, getConfirmOrderData, getIsConfirmOrderAPiPending } from '../../../selectors/travelUg/payments';
import axios from 'axios';
import { getCustomerIdValue } from '../../../selectors/travelUg/quote';
//import benefitsData from '../../../../site-builder/src/applications/travelUg/GetQuote/benefits.json';

export const orderConfirmationService = async (store, next, action) => {
    const state = store.getState();

    if (getIsConfirmOrderAPiPending(state)) {
        return next(action);
    }

    const orderData = getConfirmOrderData(state);

    if (orderData?.base64?.[0]) {
        return next(action);
    }

    store.dispatch(apiTransitionOrderConfirmation.pending());

    try {
        store.dispatch(setSelectedFormValue('confirmOrder'));

        const response = await confirmInsuranceOrder(state);
        store.dispatch(confirmOrderSuccess(response.data));
        store.dispatch(apiTransitionOrderConfirmation.success());
    } catch (error) {
        console.error('Error during order confirmation:', error);

        const status = error?.response?.data?.status;
        if (status === 401 || status === 403) {
            store.dispatch(setExpiredAuth(true));
        }

        store.dispatch(apiTransitionOrderConfirmation.failure());
        store.dispatch(confirmOrderFailure(error));
    }

    return next(action);
};

/*
const getSelectedCoverBenefits = (selectedCover) => {
    if (typeof selectedCover.value !== 'string') return [];

    const product = benefitsData.find((p) => p.product === selectedCover.value);

    return product ? product.benefits : [];
};
*/

const confirmOrderPayload = (state) => {
    const customerId = getCustomerIdValue(state) || '';
    //const quotation = getQuoteForm(state);
    //const benefits = getSelectedCoverBenefits(quotation.selectedCover);

    const payload = {
        id: customerId.value,
    };

    return {
        ...payload,
    };
};

const confirmInsuranceOrder = async (state) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/travel-ug/order/confirmation';
        const response = await axios.post(url, confirmOrderPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
        return response;
    } catch (e) {
        // if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
        //     store.dispatch(setExpiredAuth(true));
        // }
        console.error(e);
        throw e;
    }
};
